<form [formGroup]="mainForm">
    <h1 mat-dialog-title>{{ 'REVIEW_PERIOD_CUSTOM_GOALS.TITLE' | translate }}</h1>
    <div mat-dialog-content>
        <div class="flex-v">
            <mat-form-field appearance="outline">
                <mat-label>{{ 'REVIEW_PERIOD_EDIT.NAME_HU' | translate }}</mat-label>
                <input matInput formControlName="nameHu" autocomplete="off" required>
                <mat-error msg></mat-error>
            </mat-form-field>
        
            <mat-form-field appearance="outline">
                <mat-label>{{ 'REVIEW_PERIOD_EDIT.NAME_EN' | translate }}</mat-label>
                <input matInput formControlName="nameEn" autocomplete="off" required>
                <mat-error msg></mat-error>
            </mat-form-field>
        
            <div>{{ 'REVIEW_PERIOD_CUSTOM_GOALS.WHO_CAN_EDIT' | translate }}</div>
            <div>
                <mat-checkbox class="multiline" formControlName="isAllowChangeForLeader">{{ 'REVIEW_PERIOD_EDIT.LEADER' | translate }}</mat-checkbox>
                <mat-checkbox class="multiline" formControlName="isAllowChangeForSelf">{{ 'REVIEW_PERIOD_EDIT.SELF' | translate }}</mat-checkbox>
                <mat-checkbox class="multiline" formControlName="isAllowChangeForAssistant">{{ 'REVIEW_PERIOD_EDIT.ASSISTANT' | translate }}</mat-checkbox>
            </div>
        </div>
    </div>
    <div mat-dialog-actions class="flex-h flex-end">
          <button mat-flat-button color="primary" (click)="ok()" type="submit">{{ 'GENERAL.OK' | translate }}</button>
          <button mat-flat-button color="accent" [mat-dialog-close]>{{ 'GENERAL.CANCEL' | translate }}</button>
    </div>
</form>
